import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { mockServices } from '../mock';
import SEO from '../components/SEO';
import seoConfig from '../config/seoConfig';

const Services = () => {
  return (
    <>
      <SEO
        title={seoConfig.services.title}
        description={seoConfig.services.description}
        keywords={seoConfig.services.keywords}
      />
      <div className="dark-page">
      <section className="page-hero">
        <div className="hero-image-wrapper">
          <img 
            src="https://images.unsplash.com/photo-1497366754035-f200968a6e72" 
            alt="Modern office technology workspace"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <h1 className="display-large">IT & AI Solutions That Move Your Business Forward</h1>
        <p className="body-large page-subtitle">
          From intelligent automation to enterprise AI—we help you overcome technology roadblocks, drive transformation, and scale with confidence.
        </p>
      </section>

      <section className="services-detail-section">
        {mockServices.map((service, index) => (
          <div key={service.id} className={`service-detail-card ${index % 2 === 1 ? 'reverse' : ''}`}>
            <div className="service-detail-content">
              <h2 className="display-medium">{service.title}</h2>
              <p className="body-large service-description">{service.description}</p>
              
              <div className="service-features">
                <h3 className="heading-3">Key Features</h3>
                <ul className="feature-list">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="body-medium">{feature}</li>
                  ))}
                </ul>
              </div>

              <Link to={`/services/${service.slug}`} className="btn-primary">
                Learn More <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        ))}
      </section>

      <section className="cta-section">
        <h2 className="display-medium">Need a Custom Solution?</h2>
        <p className="body-large cta-subtitle">
          Every business faces unique challenges. We specialize in tailoring our IT and AI services to deliver the exact outcomes you need.
        </p>
        <Link to="/contact" className="btn-primary btn-large">
          Start the Conversation
          <ArrowRight size={24} />
        </Link>
      </section>
    </div>
    </>
  );
};

export default Services;